
import { call, put, takeEvery } from "redux-saga/effects";
import { dotDongTuiApi } from "../../../api/tct/dotDongTuiApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IDotDongTui } from "../../../model/respone/tct/IDotDongTui";
import { eDotDongTuiActionIds, IDotDongTuiActionTypes } from "../../action-types/tct/IDotDongTuiActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.toChucThi.dotDongTui;
export function* dotDongTuiSaga(): any {
    yield takeEvery(eDotDongTuiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eDotDongTuiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eDotDongTuiActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDotDongTuiActionTypes): any {
    const res: IBaseRespone = yield call(dotDongTuiApi.SelectByNamHoc, action.payload as string)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IDotDongTuiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IDotDongTui
    if (payload.id > 0) {
        res = yield call(dotDongTuiApi.Update, payload)
    } else {
        res = yield call(dotDongTuiApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IDotDongTuiActionTypes): any {
    const res: IBaseRespone = yield call(dotDongTuiApi.Deletes, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}